export const PERIODIC_GRN_REPORT = 'PERIODIC_GRN_REPORT'
export const PERIODIC_GRN_REPORT_SUCCESS = 'PERIODIC_GRN_REPORT_SUCCESS'

export const PERIODIC_GRN_REPORT_ERROR_ACTION = 'PERIODIC_GRN_REPORT_ERROR_ACTION'